import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const MapShell = styled.div`
  width: 100%;
  height: 100%;
  min-height: 28rem;
  overflow: hidden;
  background: ${tokens.surface.raised};
`

export const MapLoading = styled.div`
  width: 100%;
  height: 100%;
  min-height: 28rem;
  background: ${tokens.surface.inset};
  display: flex;
  align-items: center;
  justify-content: center;
`
